import React, { Component } from 'react';
import { connect } from 'react-redux';
import BookingFilters from 'Components/BookingCopy/BookingFilters';
import BookingTable from 'Components/BookingCopy/BookingTable';
import UploadBookingCopyModal from 'Components/BookingCopy/UploadBookingCopyModal';
import UploadBLModal from 'Components/BookingCopy/UploadBLModal';
import ViewBLDocumentsModal from 'Components/BookingCopy/ViewBLDocumentsModal';
import ConfirmModal from 'Components/BookingCopy/ConfirmModal';
import { DownloadIcon } from 'Components/BookingCopy/shared/icons';
import ActionBlurLoader from 'Components/ActionLoader/LoaderWithBlur';
import {
  GET_BOOKING_REFERENCE_LIST,
  UPLOAD_BOOKING_REFERENCE,
  SAVE_BOOKING_REFERENCE,
  UPDATE_BOOKING_COPY,
  MANAGE_BOOKING_BL,
  DELETE_BOOKING_OCR_DATA,
  DOWNLOAD_BOOKING_OCR_REPORT,
} from 'Constants/actionConstants';
import { getUser } from 'Utils/storage';
import styles from './BookingCopy.module.scss';

const PAGE_SIZE = 20;

class BookingCopy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandedRow: null,
      modal: null,        // 'uploadBookingCopy' | 'uploadBL' | 'viewBL'
      selectedRfq: null,
      selectedDoc: null,
      page: 1,
      filters: {},
      pendingDocs: {},    // { [rfqId]: { file, rfqParams, doc } }
      confirmModal: null, // { message, onConfirm }
    };
  }

  componentDidMount() {
    this.fetchList();
  }

  fetchList = (overrides = {}) => {
    const { dispatch } = this.props;
    const { page, filters } = this.state;
    const params = {
      page: (page - 1),
      size: PAGE_SIZE,
      ...filters,
      ...overrides,
    };
    // strip empty values
    Object.keys(params).forEach(k => {
      if (params[k] === '' || params[k] === undefined || params[k] === null) {
        delete params[k];
      }
    });
    dispatch({ type: GET_BOOKING_REFERENCE_LIST, params });
  };

  toggleRow = (id) => {
    this.setState(prev => ({
      expandedRow: prev.expandedRow === id ? null : id,
    }));
  };

  openModal = (type, rfq, doc = null) => {
    this.setState({ modal: type, selectedRfq: rfq, selectedDoc: doc });
  };

  closeModal = () => {
    this.setState({ modal: null, selectedRfq: null, selectedDoc: null });
  };

  openUploadBLFromViewModal = () => {
    const { selectedRfq, selectedDoc } = this.state;
    this.setState({ modal: 'uploadBL', selectedRfq, selectedDoc });
  };

  handlePageChange = (newPage) => {
    this.setState({ page: newPage }, () => {
      this.fetchList({ page: newPage - 1 });
    });
  };

  handleFilterChange = (newFilters) => {
    this.setState({ filters: newFilters, page: 1 }, () => {
      this.fetchList({ page: 0, ...newFilters });
    });
  };

  handleUploadBookingCopy = (file) => {

    const { dispatch } = this.props;
    const { selectedRfq } = this.state;
    if (!file || !selectedRfq) return;

    const user = getUser() || {};
    const rfqParams = {
      rfq_id: selectedRfq.rfq_id,
      rfq_number: selectedRfq.rfqNumber,
      contract_tenure_from: selectedRfq.contractTenureFrom,
      contract_tenure_to: selectedRfq.contractTenureTo,
      seeker_company_id: user.companyId || '',
      transporter_id: selectedRfq.transporter_id,
      transporter_name: selectedRfq.serviceProvider,
      liner_id: selectedRfq.liner_id,
      liner_name: selectedRfq.shippingLiner,
      containerType: selectedRfq.containerType || '',
      from: selectedRfq.from,
      to: selectedRfq.to,
      trip_id: selectedRfq.trip_id || '',
      user_id: user.userId || user.id || '',
      user_name: user.name || user.companyName || '',
      file_name: file.name,
      file_type: file.name.toLowerCase().endsWith('.pdf') ? 'pdf' : 'jpeg',
    };

    dispatch({
      type: UPLOAD_BOOKING_REFERENCE,
      data: { file, params: rfqParams },
      onSuccess: (ocrResult) => {
        const pendingDoc = {
          id: null,
          isPending: true,
          name: file.name,
          bookingDate: ocrResult.booking_date || '',
          bookingNo: ocrResult.booking_no || '',
          product: ocrResult.product_commodity || '',
          receiptPlace: ocrResult.place_of_receipt || '',
          loadingPort: ocrResult.port_of_loading || '',
          dischargePort: ocrResult.port_of_discharge || '',
          srcCountry: ocrResult.source_country || '',
          destCountry: ocrResult.destination_country || '',
          vessel: ocrResult.vessel_voyage || '',
          etdAtPol: ocrResult.vessel_etd_at_pol || '',
          expectedDelivery: ocrResult.expected_date_of_delivery || '',
          noOfContainers: ocrResult.no_of_containers || '',
          containerSize: ocrResult.container_size || '',
          containerType: ocrResult.container_type || '',
          vendorName: ocrResult.vendor_name || '',
          shippingLine: ocrResult.shipping_line || '',
          transshipmentPort: ocrResult.transshipment_port || '',
          transshipmentEta: ocrResult.transshipment_eta || '',
          transshipmentVesselVoyage: ocrResult.transshipment_vessel_voyage || '',
        };
        this.setState(prev => ({
          pendingDocs: {
            ...prev.pendingDocs,
            [selectedRfq.id]: { rfqParams, ocrResult, doc: pendingDoc },
          },
        }));
        this.closeModal();
      },
    });
  };

  handleSavePendingDoc = (rfq) => {
    const { dispatch } = this.props;
    const pending = this.state.pendingDocs[rfq.id];
    if (!pending) return;

    const { rfqParams, ocrResult } = pending;
    const params = {
      ...rfqParams,
      booking_id: '',
      booking_no: ocrResult.booking_no || '',
      booking_date: ocrResult.booking_date || '',
      product_commodity: ocrResult.product_commodity || '',
      place_of_receipt: ocrResult.place_of_receipt || '',
      port_of_loading: ocrResult.port_of_loading || '',
      port_of_discharge: ocrResult.port_of_discharge || '',
      source_country: ocrResult.source_country || '',
      destination_country: ocrResult.destination_country || '',
      vessel_voyage: ocrResult.vessel_voyage || '',
      vessel_etd_at_pol: ocrResult.vessel_etd_at_pol || '',
      expected_date_of_delivery: ocrResult.expected_date_of_delivery || '',
      no_of_containers: ocrResult.no_of_containers != null ? String(ocrResult.no_of_containers) : '',
      container_size: ocrResult.container_size != null ? String(ocrResult.container_size) : '',
      container_type: ocrResult.container_type || '',
      vendor_name: ocrResult.vendor_name || '',
      shipping_line: ocrResult.shipping_line || '',
      transshipment_port: ocrResult.transshipment_port || '',
      transshipment_eta: ocrResult.transshipment_eta || '',
      transshipment_etd: ocrResult.transshipment_etd || '',
      transshipment_vessel_voyage: ocrResult.transshipment_vessel_voyage || '',
    };

    dispatch({
      type: SAVE_BOOKING_REFERENCE,
      data: { params },
      onSuccess: () => {
        this.setState(prev => {
          const pendingDocs = { ...prev.pendingDocs };
          delete pendingDocs[rfq.id];
          return { pendingDocs };
        });
        this.fetchList();
      },
    });
  };

  handleDiscardPendingDoc = (rfq) => {
    this.setState(prev => {
      const pendingDocs = { ...prev.pendingDocs };
      delete pendingDocs[rfq.id];
      return { pendingDocs };
    });
  };

  handleUploadBL = (blNumber, file) => {
    const { dispatch } = this.props;
    const { selectedDoc } = this.state;
    if (!selectedDoc) return;

    const params = {
      file_id: selectedDoc.id,
      action: 'add',
      bl_number: blNumber,
    };

    dispatch({
      type: MANAGE_BOOKING_BL,
      data: { file: file || null, params },
      onSuccess: () => {
        this.closeModal();
        this.fetchList();
      },
    });
  };

  handleDeleteBL = (blId) => {
    const { dispatch } = this.props;
    const { selectedDoc } = this.state;
    if (!selectedDoc) return;

    dispatch({
      type: MANAGE_BOOKING_BL,
      data: {
        file: null,
        params: {
          file_id: selectedDoc.id,
          action: 'delete',
          bl_id: blId,
        },
      },
      onSuccess: () => {
        this.fetchList();
      },
    });
  };

  handleSaveDoc = (_rfq, doc) => {
    const { dispatch } = this.props;
    dispatch({
      type: UPDATE_BOOKING_COPY,
      data: {
        file_id: doc.id,
        booking_no: doc.bookingNo,
        booking_date: doc.bookingDate,
        product_commodity: doc.product,
        place_of_receipt: doc.receiptPlace,
        port_of_loading: doc.loadingPort,
        port_of_discharge: doc.dischargePort,
        source_country: doc.srcCountry,
        destination_country: doc.destCountry,
        vessel_voyage: doc.vessel,
        vessel_etd_at_pol: doc.etdAtPol,
        expected_date_of_delivery: doc.expectedDelivery,
        no_of_containers: doc.noOfContainers,
        container_size: doc.containerSize,
        container_type: doc.containerType,
        vendor_name: doc.vendorName,
        shipping_line: doc.shippingLine,
        transshipment_port: doc.transshipmentPort,
        transshipment_eta: doc.transshipmentEta,
        transshipment_vessel_voyage: doc.transshipmentVesselVoyage,
      },
      onSuccess: () => {
        this.fetchList();
      },
    });
  };

  handleDeleteDoc = (doc) => {
    this.setState({
      confirmModal: {
        message: `Are you sure you want to delete "${doc.name}"? This action cannot be undone.`,
        onConfirm: () => {
          this.setState({ confirmModal: null });
          const { dispatch } = this.props;
          dispatch({
            type: DELETE_BOOKING_OCR_DATA,
            data: { file_id: doc.id },
            onSuccess: () => {
              this.fetchList();
            },
          });
        },
      },
    });
  };

  handleDeleteOcrData = (fileId) => {
    const { dispatch } = this.props;
    dispatch({
      type: DELETE_BOOKING_OCR_DATA,
      data: { file_id: fileId },
      onSuccess: () => {
        this.fetchList();
      },
    });
  };

  handleDownload = () => {
    const { dispatch } = this.props;
    const { filters } = this.state;
    // Report API uses ffCompanyId, not serviceProviderId
    const { serviceProviderId, fromLocation, toLocation, bookingNo, ...rest } = filters;
    const reportParams = { ...rest };
    if (serviceProviderId) reportParams.ffCompanyId = serviceProviderId;
    dispatch({
      type: DOWNLOAD_BOOKING_OCR_REPORT,
      params: reportParams,
    });
  };

  render() {
    const {
      list, total, isFetching, uploadSubmitting, blManageSubmitting, reportDownloading,
      updateSubmitting, deleteSubmitting, loader,
    } = this.props;
    const { expandedRow, modal, selectedRfq, selectedDoc, page, pendingDocs, confirmModal } = this.state;

    return (
      <div className={styles.pageWrapper}>
        {loader && <ActionBlurLoader fixed={true} />}
        <main className={styles.content}>
          <div className={styles.pageHeader}>
            <h1 className={styles.pageTitle}>Booking Details</h1>
            <button
              className={styles.downloadBtn}
              onClick={this.handleDownload}
              disabled={reportDownloading}
            >
              <DownloadIcon /> {reportDownloading ? 'Downloading...' : 'Download'}
            </button>
          </div>

          <BookingFilters
            onFilterChange={this.handleFilterChange}
          />

          <BookingTable
            data={list}
            expandedRow={expandedRow}
            page={page}
            totalItems={total}
            pageSize={PAGE_SIZE}
            isFetching={isFetching}
            onToggleRow={this.toggleRow}
            onPageChange={this.handlePageChange}
            onUploadBookingCopy={(rfq, doc) => this.openModal('uploadBookingCopy', rfq, doc)}
            onUploadBL={(rfq, doc) => this.openModal('uploadBL', rfq, doc)}
            onViewBL={(rfq, doc) => this.openModal('viewBL', rfq, doc)}
            onSaveDoc={this.handleSaveDoc}
            onDeleteDoc={this.handleDeleteDoc}
            updateSubmitting={updateSubmitting}
            deleteSubmitting={deleteSubmitting}
            pendingDocs={pendingDocs}
            onSavePendingDoc={this.handleSavePendingDoc}
            onDiscardPendingDoc={this.handleDiscardPendingDoc}
            saveSubmitting={uploadSubmitting}
          />
        </main>

        {modal === 'uploadBookingCopy' && selectedRfq && (
          <UploadBookingCopyModal
            rfq={selectedRfq}
            doc={selectedDoc}
            submitting={uploadSubmitting}
            onUpload={this.handleUploadBookingCopy}
            onClose={this.closeModal}
          />
        )}

        {modal === 'uploadBL' && selectedRfq && (
          <UploadBLModal
            rfq={selectedRfq}
            doc={selectedDoc}
            submitting={blManageSubmitting}
            onUpload={this.handleUploadBL}
            onClose={this.closeModal}
          />
        )}

        {modal === 'viewBL' && selectedRfq && selectedDoc && (
          <ViewBLDocumentsModal
            rfq={selectedRfq}
            doc={selectedDoc}
            onClose={this.closeModal}
            onUploadBL={this.openUploadBLFromViewModal}
            onDelete={this.handleDeleteBL}
          />
        )}

        {confirmModal && (
          <ConfirmModal
            title="Delete Booking Copy"
            message={confirmModal.message}
            confirmLabel="Delete"
            onConfirm={confirmModal.onConfirm}
            onCancel={() => this.setState({ confirmModal: null })}
            submitting={deleteSubmitting}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.bookingReference.list,
  total: state.bookingReference.total,
  isFetching: state.bookingReference.isFetching,
  uploadSubmitting: state.bookingReference.uploadSubmitting,
  updateSubmitting: state.bookingReference.updateSubmitting,
  deleteSubmitting: state.bookingReference.deleteSubmitting,
  blManageSubmitting: state.bookingReference.blManageSubmitting,
  reportDownloading: state.bookingReference.reportDownloading,
  loader: state.contracting.loader,
});

export default connect(mapStateToProps)(BookingCopy);
